(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mobile-nav"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  const button = event.target.closest('.fm-concern-menu .js-toggle-submenu');
  if (!button) return;
  const drawer = button.closest('header-drawer');
  if (drawer) requestAnimationFrame(function() { drawer.scrollTo({ top: 0, behavior: 'instant' }); });
});
  } catch(e) { console.error(e); }
})();

})();
